export function buildRibbonName(): string {
    return 'Риббон'
}
